export function ExternalLinkIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6.66675 3.99984H4.00008C3.2637 3.99984 2.66675 4.59679 2.66675 5.33317V11.9998C2.66675 12.7362 3.2637 13.3332 4.00008 13.3332H10.6667C11.4031 13.3332 12.0001 12.7362 12.0001 11.9998V9.33317M9.33341 2.6665H13.3334M13.3334 2.6665V6.6665M13.3334 2.6665L6.66675 9.33317'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
